export default __webpack_public_path__ + "static/media/elk.6a717156.png";